// ============================================================
// 滚动显现：IntersectionObserver 驱动 .load-hidden
// （替代原 scrollreveal CDN，零外部依赖）
// ============================================================

export default function initReveal() {
  const items = document.querySelectorAll(".load-hidden, [data-reveal]");
  if (!items.length) return;

  if (!("IntersectionObserver" in window)) {
    items.forEach((el) => el.classList.add("is-visible"));
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: "0px 0px -36px 0px" }
  );

  items.forEach((el) => io.observe(el));
}
